export const APP_BUNDLES = 'APP_BUNDLES'
export const APP_OPEN_BUNDLES = 'APP_OPEN_BUNDLES'
export const APP_DATES = 'APP_DATES'
export const APP_USER = 'APP_USER'
export const APP_VERSION = 'APP_VERSION'
export const APP_REPORTED = 'APP_REPORTED'
export const APP_DELIVERY_DATES = 'APP_DELIVERY_DATES'
export const APP_BOTTOM_NAV_LOCKED = 'APP_BOTTOM_NAV_LOCKED'
export const APP_LAST_SELECTED_BUNDLE_ID = 'APP_LAST_SELECTED_BUNDLE_ID'
export const APP_MODE = 'APP_MODE'
export const APP_PAPERS = 'APP_PAPERS'
export const APP_ALERTS_SHOWN = 'APP_ALERTS_SHOWN'
export const APP_IMPERSONATED_ID = 'APP_IMPERSONATED_ID'

